module.exports = __webpack_public_path__ + "img/and_pump.577d2058.png";